import { atom } from 'jotai'

export const locationGeometryAtom = atom({ lat: 0, lng: 0 })
